export function requestFullScreen() {
  if (!document.fullscreenElement) {
    document.documentElement.requestFullscreen().catch(err => {
      alert(`Erreur lors de la tentative de passage en plein écran : ${err.message} (${err.name})`);
    });
  }
}

export function exitFullScreen() {
  if (document.fullscreenElement) {
    document.exitFullscreen().catch(err => {
      alert(`Erreur lors de la tentative de sortie du plein écran : ${err.message} (${err.name})`);
    });
  }
}
